import React, { useEffect, useRef } from 'react';

const PurchaseSuccess = () => {
  const tracked = useRef(false);

  useEffect(() => {
    // Prevent search engine indexing
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    // Fire Meta Pixel Purchase event — once
    if (!tracked.current) {
      tracked.current = true;
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Purchase', {
          content_name: 'Vivos no Espírito',
          value: 27.00,
          currency: 'BRL',
        });
      }
    }

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="purchase-success-page" data-testid="purchase-success">
      <div className="container">
        <div className="purchase-success-content">
          <h1 className="purchase-success-title">Bem-vindo à jornada.</h1>
          <p className="purchase-success-message">
            Sua decisão de construir sobre a Rocha foi registrada. Você receberá os dados de acesso no e-mail cadastrado.
          </p>
          <p className="purchase-success-next">
            Enquanto isso, prepare-se: amanhã será o primeiro dia dos 14 dias em Romanos.
          </p>
          <p className="purchase-success-blessing">
            Que o Senhor o conduza com sabedoria e firmeza.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PurchaseSuccess;
